export default __webpack_public_path__ + "static/media/OfficeDepot-Button.852f38b7.png";